import { render, staticRenderFns } from "./StudentsListToggle.vue?vue&type=template&id=b47f54a8&scoped=true&"
import script from "./StudentsListToggle.vue?vue&type=script&lang=js&"
export * from "./StudentsListToggle.vue?vue&type=script&lang=js&"
import style0 from "./StudentsListToggle.vue?vue&type=style&index=0&id=b47f54a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47f54a8",
  null
  
)

export default component.exports